<template>
  <div id="app">
    <BrowserWarning />
    <!-- <BrowserWarning v-if="isWeChatBrowser" /> -->
    <component :is="currentView" />
  </div>
</template>

<script>
import { isMobile } from './utils/device';
import MobileView from './views/MobileView.vue';
import PCView from './views/PCView.vue';
import MobileInviteView from './views/MobileInviteView.vue';

export default {
  name: 'App',
  components: {
    MobileView,
    PCView,
    MobileInviteView
  },
  data() {
    return {
      // currentView: isMobile() ? 'MobileView' : 'PCView'
      currentView: isMobile() ? 'MobileInviteView' : 'PCView'
    };
  },
  // mounted() {
  //   this.initScripts();
  // },
  // methods: {
  //   initScripts() {
  //     // 创建百度统计脚本
  //     const script = document.createElement('script');
  //     script.innerHTML = `var _hmt = _hmt || [];
  //       (function() {
  //         var hm = document.createElement("script");
  //         hm.src = "https://hm.baidu.com/hm.js?6364f3f338cf337df28d9a4d7b818dd5";
  //         var s = document.getElementsByTagName("script")[0];
  //         s.parentNode.insertBefore(hm, s);
  //       })();
  //     `;
  //     document.head.appendChild(script);
  //   }
  // }
};
</script>
<style lang="scss" scoped>
</style>
